// frontend/src/components/MessageList.tsx
import React, { useRef, useEffect } from 'react';
import { MessageItem } from './MessageItem'; // Importar MessageItem
import Spinner from 'react-bootstrap/Spinner';

// Interfaz Msg (puede venir de types.ts)
interface Msg {
    id: string | number;
    from: 'user' | 'bot' | 'error';
    text: string;
}

interface MessageListProps {
    history: Msg[];
    isLoading: boolean;
}

export function MessageList({ history, isLoading }: MessageListProps) {
    const messageEndRef = useRef<HTMLDivElement>(null);

    // Autoscroll
    useEffect(() => {
        messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [history]); // Depende solo del historial

    return (
        // Contenedor con scroll y algo de padding
        <div style={{ flexGrow: 1, overflowY: 'auto', padding: '0.5rem', borderBottom: '1px solid #eee' }}>
            {history.map((msg) => (
                <MessageItem key={msg.id} message={msg} />
            ))}
            {/* Indicador de carga mejorado */}
            {isLoading && (
                <div className="text-center py-2">
                    <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="ms-2 fst-italic text-muted">Pensando...</span>
                </div>
            )}
            {/* Elemento invisible para autoscroll */}
            <div ref={messageEndRef} />
        </div>
    );
}